import { Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import TabPanel from "../../components/TabPanel";
import ColorsList from "./ColorsList";
import FinishesList from "./FinishesList";
import VinylsList from "./VinylsList";

export default function Colors() {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Tabs value={tabValue} onChange={handleChange} aria-label="tabs">
        <Tab label="Wrap Colors" />
        <Tab label="Finishes" />
        <Tab label="Vinyl Brands" />
      </Tabs>
      <TabPanel value={tabValue} index={0}>
        <ColorsList />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <FinishesList />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <VinylsList />
      </TabPanel>
    </>
  );
}
